var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"docs-type"},[_vm._v("\n  "+_vm._s(_vm.nullable ? '?' : '')+_vm._s(_vm.variable ? '...' : '')),_vm._l((_vm.names),function(type){return _c('type-link',{key:_vm.typeKey(type),attrs:{"type":type,"docs":_vm.docs}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0570eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/docs/Types.vue
// module id = null
// module chunks = 